<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-2">
            <div class="form-group">
              <label for="search-position-name">
                {{ i18n("Position.PositionName") }}
              </label>
              <input
                type="text"
                id="search-position-name"
                class="form-control"
                maxlength="50"
                placeholder="請輸入關鍵字"
                v-model.trim="search.PositionName"
                @keyup.enter="getPosition(), tableInfo.page = 1"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-2">
            <div class="form-group">
              <label for="search-position-property">職務性質</label>
              <select id="search-position-property" class="form-control" v-model="search.positionProperty">
                <option :value="null">全部</option>
                <option value="全職">全職</option>
                <option value="兼職">兼職</option>
                <option value="高階">高階</option>
              </select>
            </div>
          </div>
          <div class="col-sm-3 col-md-2">
            <div class="form-group">
              <label for="search-position-status">{{ i18n("Position.Status") }}</label>
              <select id="search-position-status" class="form-control" v-model="search.isEnabled">
                <option :value="null">全部</option>
                <option :value="true">啟用</option>
                <option :value="false">停用</option>
              </select>
            </div>
          </div>
          <div class="col-sm-3 col-md-4">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="getPosition"
            >
              {{ i18n("Buttons.Search") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              data-toggle="modal"
              data-target="#positionModal"
              @click="positionModal({ action: 'add' })"
            >
              {{ i18n("Buttons.Add") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="IsSupervisor" slot-scope="props">
          <span v-if="props.cell_value">是</span>
          <span v-else>否</span>
        </template>

        <template slot="IsEnabled" slot-scope="props">
          <eva-icon
            v-if="props.cell_value"
            fill="#000"
            name="checkmark-outline"
          />
          <eva-icon v-else fill="#000" name="close-outline" />
        </template>

        <template slot="Edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#positionModal"
            @click="positionModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>
        <template slot="Delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delPositionModal"
            @click="position = { ...props.row }"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal-->
    <div
      id="positionModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="position"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">
                {{ i18n("Position.AddPosition") }}
              </span>
              <span v-else>{{ i18n("Position.EditPosition") }}</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider
                  :name="i18n('Position.PositionCode')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="modal-position-code">
                    <span class="mark">*</span>
                    {{ i18n("Position.PositionCode") }}
                  </label>
                  <input
                    type="text"
                    id="modal-position-code"
                    class="form-control"
                    maxlength="10"
                    v-model.trim="position.PositionCode"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider
                  :name="i18n('Position.PositionName')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="modal-position-name">
                    <span class="mark">*</span>
                    {{ i18n("Position.PositionName") }}
                  </label>
                  <input
                    type="text"
                    id="modal-position-name"
                    class="form-control"
                    maxlength="50"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="position.PositionName"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="modal-position-property">
                    <span class="mark">*</span>
                    職務性質
                  </label>
                  <select
                    id="modal-position-property"
                    class="form-control"
                    v-model="position.PositionProperty"
                  >
                    <option :value="null" disabled>請選擇</option>
                    <option value="全職">全職</option>
                    <option value="兼職">兼職</option>
                    <option value="高階">高階</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label for="modal-position-instruction">
                  {{ i18n("Position.JobDescription") }}
                </label>
                <textarea
                  type="text"
                  id="modal-position-instruction"
                  class="form-control"
                  cols="50"
                  rows="5"
                  maxlength="400"
                  v-model="position.PositionInstruction"
                />
              </div>
              <div class="form-group">
                <ValidationProvider
                  :name="i18n('Basic.Enable')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="modal-position-is-enabled">
                    <span class="mark">*</span>
                    {{ i18n("Basic.Enable") }}
                  </label>
                  <select id="modal-position-is-enabled" class="form-control" v-model="position.IsEnabled">
                    <option :value="true">是</option>
                    <option :value="false">否</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }} </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(savePosition)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal-->
    <div
      id="delPositionModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">{{ i18n("Position.DeletePosition") }}</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ position.PositionName }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delPosition"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "JobMaintenance",

  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      // 判斷新增、編輯
      action: "add",

      position: {},

      search: {
        positionProperty: null,
        isEnabled: null,
      },

      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: this.i18n("Position.PositionCode"),
          name: "PositionCode",
        },
        {
          label: this.i18n("Position.PositionName"),
          name: "PositionName",
        },
        {
          label: "職務性質",
          name: "PositionProperty",
        },
        {
          label: this.i18n("Basic.Enable"),
          name: "IsEnabled",
          slot: "IsEnabled",
        },
        {
          label: "",
          name: "Edit",
          slot_name: "Edit",
        },
        {
          label: "",
          name: "Delete",
          slot_name: "Delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  methods: {
    // 換頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getPosition();
    },

    // 取得 職務
    getPosition() {
      this.updateLoading(true);
      this.$api.position
        .getPositionPaging({
          ...this.search,
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Datas;
            this.totalData = response.data.Quantity;
          }
          this.updateLoading(false);
        });
    },

    // 職務 Modal
    positionModal({ action, data }) {
      switch (action) {
        case "add":
          this.position = {};
          this.$set(this.position, "PositionProperty", null);
          this.$set(this.position, "IsEnabled", true);
          this.action = "add";
          break;
        case "edit":
          this.position = {
            PositionCode: data.PositionCode,
            PositionName: data.PositionName,
            PositionProperty: data.PositionProperty,
            PositionInstruction: data.PositionInstruction,
            IsEnabled: data.IsEnabled,
            Guid: data.Guid,
          };
          this.action = "edit";
          break;
      }
      this.$refs.position.reset();
    },

    // 新增、編輯 職務
    savePosition() {
      $("#positionModal").modal("hide");
      let message;
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.position
            .postPosition({
              ...this.position,
              CreateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getPosition();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.position
            .putPosition({
              ...this.position,
              UpdateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getPosition();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 刪除 職務
    delPosition() {
      this.updateLoading(true);
      this.$api.position
        .deletePosition(this.position.PositionCode)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getPosition();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(['updateLoading']),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    }
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
